import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "admin-chance-lat",
  storage: window.localStorage,
  modules: [
    "titlepage",
    "user",
    "role",
    "selectedEvent",
    "darkmode",
    "business",
    "selectedCorporative",
  ],
});

export default new Vuex.Store({
  state: {
    search: "",
    searchPlaceholder: "",
    visibleSearch: true,
    business: null,
    selectedEvent: null,
    selectedCorporative: "",
    titlepage: "",
    darkmode: true,
    user: {},
    role: "",
    SnackbarAlert: {
      text: "",
      timeout: 2000,
      btn_closed: false,
      icon: false,
      type: "",
    },
  },
  mutations: {
    AlertSnackbar(state, config) {
      state.SnackbarAlert = config;
      return state.SnackbarAlert;
    },
    mode(state, mode) {
      state.darkmode = mode;
      return state.darkmode;
    },
    setUser(state, target) {
      state.user = target;
      state.role = target?.role || "";
    },
    setselectedEvent(state, target) {
      state.selectedEvent = target;
      state.selectedCorporative = target;
    },
    setAddNewCover(state, target) {
      state.selectedEvent.cover = target;
  
    },
    setBusiness(state, target) {
      state.business = target;
    },
    setAppFrame(state, target) {
      state.appFrame = target;
    },
    visibleSearch(state, target) {
      state.visibleSearch = target;
    },
    setSearch(state, target) {
      state.search = target;
    },
    setSearchPlaceholder(state, target) {
      state.searchPlaceholder = target;
    },
    settitlepage(state, target) {
      state.titlepage = target;
    },
    setNavBar(state, target) {
      state.navBar = target;
    },
    setCorporative(state, target) {
      state.selectedCorporative = target;
    },
    setUserValidity(state, target) {
      state.userIsValid = target;
      setTimeout(() => {
        state.userIsValid = true;
      }, 3000);
    },
  },
  actions: {
    Alert_: ({ commit, state }, config) => {
      commit("AlertSnackbar", config);
    },
    mode: ({ commit, state }, mode) => {
      commit("mode", mode);
    },
    titlepage: ({ commit, state }, t) => {
      commit("settitlepage", t);
    },
    addCorporative: ({ commit, state }, business) => {
      commit("setCorporative", business);
    },
    addNewCover: ({ commit, state }, cover) => {
      commit("setAddNewCover", cover);
    },
    visibleSearch: ({ commit, state }, t) => {
      commit("visibleSearch", t);
    },
    addBusiness: ({ commit, state }, business) => {
      commit("setBusiness", business);
    },
    addEventSelection: ({ commit, state }, business) => {
      commit("setselectedEvent", business);
    },
    setUser: ({ commit, state }, user) => {
      commit("setUser", user);
    },
    // Acción para actualizar el valor de búsqueda (lo que escribe el usuario)
    setSearch: ({ commit }, value) => {
      commit("setSearch", value);
    },
    // Acción para establecer el placeholder del buscador (nombre del módulo)
    setSearchPlaceholder: ({ commit }, placeholder) => {
      commit("setSearchPlaceholder", placeholder);
    },
    // Acción para limpiar la búsqueda
    clearSearch: ({ commit }) => {
      commit("setSearch", "");
    },
    setUserValidity_: ({ commit, state }, i) => {
      commit("setUserValidity", i);
    },
  },
  getters: {
    Alert_: (state) => {
      return state.SnackbarAlert;
    },
    title: (state) => {
      return state.titlepage;
    },
    userIsValid: (state) => state.userIsValid,
    userType: (state) => state.user.type,
  },
  modules: {},
  plugins: [vuexPersist.plugin],
});
